module.exports = __webpack_public_path__ + "img/moneys.bef1d6e7.svg";